import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const AlertDesignSettings = {
  'alert-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'alert-design-typography': {
    'alert-design-title-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
    },
    'alert-design-description-typography': {
      phone: getDefaultTypography('Body Medium'),
      'phone-landscape': getDefaultTypography('Body Medium'),
      tablet: getDefaultTypography('Body Medium'),
      'tablet-landscape': getDefaultTypography('Body Medium'),
      desktop: getDefaultTypography('Body Medium'),
      tv: getDefaultTypography('Body Medium'),
    },
  },
  'alert-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'alert-design-padding': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  'alert-design-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
}
